export default __webpack_public_path__ + "static/media/iconly_bulk_notification.84022137.svg";